import useFetchAllProperties from 'components/domain/property/useFetchAllProperties';
import { API_MAX_LIMIT } from 'services/API.constants';
import getPropertiesQuery from 'utils/property/getPropertiesQuery';
import { PropertyMultiSelectFieldProps } from './PropertyMultiSelectField.types';

/**
 * Hook used by `PropertyMultiSelectField` component to fetch the list of properties it shows.
 */
const useFetchPropertiesForMultiSelect = ({
  graphQlFilters,
}: {
  graphQlFilters?: PropertyMultiSelectFieldProps['graphQlFilters'];
} = {}) => {
  return useFetchAllProperties({
    conditions: getPropertiesQuery({
      filters: { limit: API_MAX_LIMIT, ...(graphQlFilters ?? {}) },
    }),
    fields:
      'uid,name,businessType,numberOfSubUnits,unitTypes{uid,name,units{uid,name}},subUnits{uid,name}',
    operationName: 'MultiSelectFieldProperties',
    enabled: true,
  });
};

export default useFetchPropertiesForMultiSelect;
